import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CourseProvider } from "./context/CourseContext";
import { ThemeProvider } from "./context/ThemeContext";
import WelcomePage from "./pages/WelcomePage";
import CourseDashboard from "./pages/CourseDashboard";
import SectionReader from "./pages/SectionReader";

import "./App.css";

function App() {
  return (
    <ThemeProvider>
      <CourseProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/home" element={<CourseDashboard />} />
            <Route path="/section/:sectionId" element={<SectionReader />} />

          </Routes>
        </BrowserRouter>
      </CourseProvider>
    </ThemeProvider>
  );
}

export default App;
